/**
 * Microsoft Teams 임베디드 환경 여부 판별
 * AppLayout, SsoTokenProvider 등에서 공통 사용
 */
export const isInTeams = window.self !== window.top && window.name === 'embedded-page-container';
